module.exports = __webpack_public_path__ + "media/logos/dobry-wzor-badge-mail-323fda99.png";